import React                from "react";
import PropTypes            from "prop-types";
import Flux                 from "../../flux/Flux";
import VideoTile            from "../Grid2/Tiles/VideoTile";
import Grid2                from "../Grid2/Grid2";
import withVideos           from "../HigherOrderComponents/Videos/withVideos";
import withStaticLoader     from "../HigherOrderComponents/Utility/withStaticLoader";
import ActorTooFewItemsTile from "../Grid2/Tiles/ActorTooFewItemsTile";

class ProfileOverviewVideosGrid extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		if (!this.props.videos) {
			return null;
		}

		const tileData    = [...this.props.videos];
		const tileClasses = [];
		const tileSizes   = [];
		const tileConfigs = [];

		const videosCount = tileData.length;

		if (videosCount < 4) {
			tileData.push({actorId: this.props.actorId, actorName: this.props.actorName});
			tileClasses.push({index: videosCount, tileClass: ActorTooFewItemsTile});
			tileSizes.push({index: videosCount, size: {xs: videosCount === 0 ? 2 : (videosCount === 1 ? 1 : 4 - videosCount), lg: 4 - videosCount}});
			tileConfigs.push({index: videosCount, config: {}});
		}

		const isGuestLoggedIn = Flux.Guest.isLoggedIn();

		return (
			<div>
				<Grid2 tileData={tileData}
				       defaultTileClass={VideoTile}
				       tileClasses={tileClasses}
					   columns={{xs: videosCount === 0 ? 1 : 2, lg: videosCount === 0 ? 1 : 4}}
				       tileConfigs={tileConfigs}
				       defaultTileConfig={{
							footer: 		   {show: {likes: true}}, 
							badges: 		   {textBadges: {show: {price: isGuestLoggedIn}}},
							navigateTo: 	   this.props.navigateTo,
					   }}
				       tileSizes={tileSizes}
					   lazyImageLoading={this.props.lazyImageLoading}
					   headlineType={this.props.headlineType}
				/>
			</div>
		);
	}
}

ProfileOverviewVideosGrid.propTypes = {
	videos:            PropTypes.array,
	actorId:           PropTypes.number.isRequired,
	actorName:         PropTypes.string.isRequired,
	lazyImageLoading:  PropTypes.bool,
	headlineType:      PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	navigateTo:        PropTypes.func,
};

ProfileOverviewVideosGrid.defaultProps = {
	lazyImageLoading: false,
	headlineType:     Flux.Constants.Headlines.h4,
};


export default withVideos(withStaticLoader(ProfileOverviewVideosGrid));
